import React from 'react';
import { RichText, Image } from '@sitecore-jss/sitecore-jss-react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import DictionaryText from './DictionaryText';
import { getAbsoluteUrl } from '../../utils/urlHelper';

const KeyFactsCard = (props) => {
  const { title, summary , desc, link, image , sitecoreContext } = props;
  const absoluteLink = getAbsoluteUrl(link, sitecoreContext);

  return (
    <a href={absoluteLink}>
      <div className="w-full block h-fit group">

        {sitecoreContext.pageEditing ? (
          <RichText field={title} className="ext-black-300 font-bold text-[86px]/[96px] lg:text-5xl/[100%]" />
        ) : (
          <h3 className="text-black-300 font-bold text-[86px]/[96px] lg:text-5xl/[100%]">{title?.value}</h3>
        )}
        { summary && <RichText field={summary} className="mt-3 text-lg/[32px] font-bold text-black-300" />}
        { desc && <RichText field={desc} className="mt-3 text-base/[28px] font-medium text-black-300" />}

      </div>
    </a>
  );
};

export default withSitecoreContext()(KeyFactsCard);
